'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIModal from 'UIComponents/dialog/UIModal';
import { FormattedMessage, FormattedHTMLMessage } from 'LearningCenterUI/components/I18n';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import H2 from 'UIComponents/elements/headings/H2';
const BASE_I18N_KEY = 'learningCenter.practicalExercise.external';

const ReviewExerciseConfirmModal = ({
  graded,
  onConfirm,
  onReject,
  isManual
}) => /*#__PURE__*/_jsxs(UIModal, {
  "data-test-id": "practical-exercise-review-modal",
  size: "auto",
  width: 700,
  children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onReject
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${BASE_I18N_KEY}.submitWork.confirmTitle`
      })
    })]
  }), /*#__PURE__*/_jsx(UIDialogBody, {
    children: /*#__PURE__*/_jsxs(UIList, {
      childClassName: "m-y-3",
      ordered: true,
      styled: true,
      children: [graded && /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "review-exercise-graded-message",
        message: `${BASE_I18N_KEY}.warnings.requirementForCertification`
      }), isManual ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        "data-test-id": "review-exercise-approval-lag-message",
        message: `${BASE_I18N_KEY}.warnings.manualApprovalLag`
      }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        "data-test-id": "review-exercise-processing-lag",
        message: `${BASE_I18N_KEY}.warnings.processingLag`
      })]
    })
  }), /*#__PURE__*/_jsxs(UIDialogFooter, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "review-exercise-modal-ok",
      onClick: onConfirm,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${BASE_I18N_KEY}.submitWork.confirm`
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "review-exercise-modal-cancel",
      onClick: onReject,
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${BASE_I18N_KEY}.submitWork.cancel`
      })
    })]
  })]
});

ReviewExerciseConfirmModal.propTypes = {
  graded: PropTypes.bool,
  isManual: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired
};
export default ReviewExerciseConfirmModal;